module.exports = __webpack_public_path__ + "img/shape-4_gray-200.cb93e79.png";